import { WatchdogView } from "../view/view";
import {connect} from "react-redux";

interface OwnProps {
    id:string;
}

function mapStateToProps(ownProps:OwnProps){  
    const myprops=
    {
        
    }
    return myprops;
}

// function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
//     return {
//         onLoadRequested:()=>{ 
//             //dispatch(requestDataFromAPI() as any);
//         },
//     }
// }

const MandantenContainer=connect(mapStateToProps)(WatchdogView);
export default MandantenContainer;